const ACCESS_TOKEN_KEY = 'gradde_access_token';
const REFRESH_TOKEN_KEY = 'gradde_refresh_token';
const PERSIST_PREF_KEY = 'gradde_stay_signed_in';

const readFromAny = (key: string): string | null =>
    localStorage.getItem(key) ?? sessionStorage.getItem(key);

export const getAccessToken = (): string | null => readFromAny(ACCESS_TOKEN_KEY);

export const getRefreshToken = (): string | null => readFromAny(REFRESH_TOKEN_KEY);

export const setTokens = (
    accessToken: string,
    refreshToken: string,
    persistent: boolean = true,
): void => {
    // Always clear from the other store first so the two never disagree.
    const target = persistent ? localStorage : sessionStorage;
    const other = persistent ? sessionStorage : localStorage;
    other.removeItem(ACCESS_TOKEN_KEY);
    other.removeItem(REFRESH_TOKEN_KEY);
    target.setItem(ACCESS_TOKEN_KEY, accessToken);
    target.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

export const clearTokens = (): void => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
};

// "Stay signed in" preference — persisted across visits so the checkbox
// reflects the user's last choice on the sign-in page.
export const getStaySignedInPreference = (): boolean => {
    const stored = localStorage.getItem(PERSIST_PREF_KEY);
    // Default to true to preserve existing behaviour for returning users.
    return stored === null ? true : stored === '1';
};

export const setStaySignedInPreference = (value: boolean): void => {
    localStorage.setItem(PERSIST_PREF_KEY, value ? '1' : '0');
};
